import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBitbucketColor24 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#2684FF",
			d: "M2.642 3c-.4 0-.7.366-.633.733L4.707 20.25a.86.86 0 0 0 .866.732h13.054c.3 0 .566-.233.633-.533l2.73-16.684a.624.624 0 0 0-.632-.733zm11.456 11.922H9.935L8.836 9.028h6.294z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#a)",
			d: "M21.092 9.028h-5.995l-.999 5.894H9.935L5.04 20.75s.233.2.566.2H18.66c.3 0 .567-.233.633-.533z"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "a",
			x1: 22.494,
			x2: 12.56,
			y1: 10.689,
			y2: 18.443,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .176,
				stopColor: "#0052CC"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#2684FF"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgIconBitbucketColor24);
export default ForwardRef;
